class StickyAddToCart extends HTMLElement {
    constructor() {
        super(), this.sticky = this, this.stickyBounds = document.getElementById("product-add-to-cart") || document.querySelector("[data-combo-addtocart]"), this.closeSticky = this.querySelector("[data-close-sticky-add-to-cart]"), this.expandSticky = this.querySelector("[data-expand-sticky-add-to-cart]"), this.closeSticky?.addEventListener("click", this.setCloseSticky.bind(this)), this.expandSticky?.addEventListener("click", this.setExpandSticky.bind(this)), this.openStickyButton = document.getElementById("show-sticky-product"), this.closeModal = this.closeStickyModal.bind(this)
    }
    connectedCallback() {
        this.onScrollHandler = this.onScroll.bind(this), window.addEventListener("scroll", this.onScrollHandler, !1), this.openStickyButton.addEventListener("click", this.openStickyModal.bind(this)), document.addEventListener("click", t => {
            (t.target.matches(".background-overlay") || null != t.target.closest("[data-close-sticky-mobile]") || t.target.matches("[data-close-sticky-mobile]")) && this.closeModal()
        });
        let t = this.closest("[data-sticky-add-to-cart]").clientHeight;
        this.sticky.querySelector(".sticky-product-mobile").style.bottom = t + "px"
    }
    openStickyModal() {
        document.body.classList.add("show-mobile-options")
    }
    closeStickyModal() {
        document.body.classList.remove("show-mobile-options")
    }
    disconnectedCallback() {
        window.removeEventListener("scroll", this.onScrollHandler)
    }
    onScroll() {
        let t = window.pageYOffset || document.documentElement.scrollTop,
            e = $(this.stickyBounds).offset().top + $(this.stickyBounds).outerHeight(!0) - 150,
            i = window.innerHeight,
            a = document.body.clientHeight;
        if (t > e && t + i < a) {
            if (requestAnimationFrame(this.show.bind(this)), this.sticky.classList.contains("style-1")) {
                let s = 0,
                    o = document.getElementById("preview-bar-iframe"),
                    r = document.querySelector(".halo-sticky-toolbar-mobile");
                o && "none" !== window.getComputedStyle(o).display ? s = o.offsetHeight : r && (s = r.offsetHeight), this.sticky.style.top = "auto", this.sticky.style.bottom = `${s}px`
            } else if (this.sticky.classList.contains("style-2")) {
                if (document.body.classList.contains("scroll-up")) {
                    let d = document.querySelector("sticky-header").offsetHeight;
                    window.innerWidth < 551 && (d += 20), this.sticky.style.top = `${d}px`
                } else document.body.classList.contains("scroll-down") && (window.innerWidth > 550 ? this.sticky.style.top = 0 : this.sticky.style.top = "20px")
            }
        } else requestAnimationFrame(this.hide.bind(this));
        this.currentScrollTop = t
    }
    hide() {
        this.sticky.classList.remove("show-sticky", "hidden-sticky", "full-sticky", "animate"), document.body.classList.remove("show-mobile-options")
    }
    show() {
        this.sticky.classList.add("show-sticky", "animate")
    }
    setCloseSticky(t) {
        t.preventDefault(), this.sticky.classList.contains("full-sticky") ? this.sticky.classList.remove("full-sticky") : this.sticky.classList.add("hidden-sticky")
    }
    setExpandSticky(t) {
        t.preventDefault(), this.sticky.classList.add("full-sticky")
    }
}
customElements.define("sticky-add-to-cart", StickyAddToCart);
class VariantStickyAddToCart extends HTMLElement {
    constructor() {
        super(), this.item = $(this).closest(".productView"), this.sticky = $(this).closest(".productView-stickyCart"), this.addEventListener("change", this.onVariantChange.bind(this))
    }
    onVariantChange(t) {
        this.updateOptions(), this.updateMasterId(), this.updatePickupAvailability(), this.updateMedia(200), this.updateURL(), this.updateVariantInput(), this.renderProductAjaxInfo(), this.renderProductInfo(), this.updateAttribute(!this.currentVariant.available)
    }
    updateOptions() {
        this.options = Array.from(this.querySelectorAll("select"), t => t.value)
    }
    decodeOptions() {
        this.options = this.options.map(t => {
            let e = this.decodeOption(t);
            return e
        })
    }
    decodeOption(t) {
        return t ? t.split("Special_Double_Quote").join('"').split("Special_Slash").join("/") : null
    }
    encodeOption(t) {
        return t ? t.split('"').join("Special_Double_Quote").split("/").join("Special_Slash") : null
    }
    updateMasterId() {
        this.decodeOptions(), this.currentVariant = this.getVariantData().find(t => t.id == this.options)
    }
    updateMedia(t) {
        if (!this.currentVariant || !this.currentVariant?.featured_media) return;
        let e = this.item.find(".sticky-image"),
            i = this.currentVariant?.featured_image;
        if (!e) return;
        e.find("img").attr({
            src: i.src,
            srcset: i.src,
            alt: i.alt
        });
        let a = document.querySelectorAll(`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`);
        a && window.setTimeout(() => {
            $(a).trigger("click")
        }, t)
    }
    updateURL() {
        this.currentVariant && window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`)
    }
    updateVariantInput() {
        let t = document.querySelectorAll(`#product-form-${this.dataset.product}, #product-form-installment-${this.dataset.product}, #product-form-sticky-${this.dataset.product}`);
        t.forEach(t => {
            let e = t.querySelector('input[name="id"]');
            e.value = this.currentVariant.id, e.dispatchEvent(new Event("change", {
                bubbles: !0
            }))
        })
    }
    updatePickupAvailability() {
        let t = document.querySelector("pickup-availability");
        t && (this.currentVariant?.available ? t.fetchAvailability(this.currentVariant.id) : (t.removeAttribute("available"), t.innerHTML = ""))
    }
    renderProductAjaxInfo() {
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`).then(t => t.text()).then(t => {
            let e = `product-price-${this.dataset.product}`,
                i = new DOMParser().parseFromString(t, "text/html"),
                a = document.getElementById(e),
                s = i.getElementById(e);
            s && a && (a.innerHTML = s.innerHTML), document.getElementById(`product-price-${this.dataset.product}`)?.classList.remove("visibility-hidden")
        })
    }
    renderProductInfo() {
        var t = this.getVariantData().filter(t => t.available),
            e = this.currentVariant?.option1,
            i = this.currentVariant?.option2,
            a = this.currentVariant?.option3,
            s = this.item.find(".product-form__input:not(.mobile)"),
            o = this.item.find(".product-form__input.mobile");
        let r = s => {
            $.each(s, (o, r) => {
                var d = $(r).data("option-index"),
                    n = $(r).data("product-attribute");
                switch (d) {
                    case 0:
                        if ($(r).find("[data-header-option]").text(e), "set-select" == n) {
                            $(r).find(".select__select").val(e);
                            var l = $(r).find(".select__select option");
                            l.each((t, i) => {
                                i.value == e ? $(i).attr("selected", "selected") : $(i).removeAttr("selected")
                            })
                        } else $(r).find(".product-form__radio").prop("checked", !1), $(r).find(`.product-form__radio[value="${this.encodeOption(e)}"]`).prop("checked", !0);
                        var c = t.filter(t => t.option1 === e);
                        if (i) {
                            var u = $(s[1]),
                                h = u.find(".product-form__radio"),
                                p = u.find(".select__select option");
                            "set-rectangle" == n ? h.each((t, e) => {
                                var i = $(e).next(),
                                    a = $(e).val();
                                void 0 == c.find(t => t.option2 == this.decodeOption(a)) ? i.removeClass("available").addClass("soldout") : i.removeClass("soldout").addClass("available")
                            }) : p.each((t, e) => {
                                var i = $(e),
                                    a = $(e).val();
                                void 0 == c.find(t => t.option2 == this.decodeOption(a)) ? i.attr("disabled", !0) : i.removeAttr("disabled")
                            })
                        }
                        if (a) {
                            var u = $(s[2]),
                                h = u.find(".product-form__radio"),
                                p = u.find(".select__select option");
                            "set-rectangle" == n ? h.each((t, e) => {
                                var i = $(e).next(),
                                    a = $(e).val();
                                void 0 == c.find(t => t.option3 == this.decodeOption(a)) ? i.removeClass("available").addClass("soldout") : i.removeClass("soldout").addClass("available")
                            }) : electOption.each((t, e) => {
                                var i = $(e),
                                    a = $(e).val();
                                void 0 == c.find(t => t.option3 == this.decodeOption(a)) ? i.attr("disabled", !0) : i.removeAttr("disabled")
                            })
                        }
                        break;
                    case 1:
                        if ($(r).find("[data-header-option]").text(i), "set-select" == n) {
                            $(r).find(".select__select").val(i);
                            var l = $(r).find(".select__select option");
                            l.each((t, e) => {
                                e.value == i ? $(e).attr("selected", "selected") : $(e).removeAttr("selected")
                            })
                        } else $(r).find(".product-form__radio").prop("checked", !1), $(r).find(`.product-form__radio[value="${this.encodeOption(i)}"]`).prop("checked", !0);
                        var v = t.filter(t => t.option2 === i);
                        if (e) {
                            var u = $(s[0]),
                                h = u.find(".product-form__radio"),
                                p = u.find(".select__select option");
                            "set-rectangle" == n ? h.each((t, e) => {
                                var i = $(e).next(),
                                    a = $(e).val();
                                void 0 == v.find(t => t.option1 == this.decodeOption(a)) ? i.removeClass("available").addClass("soldout") : i.removeClass("soldout").addClass("available")
                            }) : p.each((t, e) => {
                                var i = $(e),
                                    a = $(e).val();
                                void 0 == v.find(t => t.option1 == this.decodeOption(a)) ? i.attr("disabled", !0) : i.removeAttr("disabled")
                            })
                        }
                        if (a) {
                            var u = $(s[2]),
                                h = u.find(".product-form__radio"),
                                p = u.find(".select__select option");
                            "set-rectangle" == n ? h.each((t, e) => {
                                var i = $(e).next(),
                                    a = $(e).val();
                                void 0 == v.find(t => t.option3 == this.decodeOption(a)) ? i.removeClass("available").addClass("soldout") : i.removeClass("soldout").addClass("available")
                            }) : electOption.each((t, e) => {
                                var i = $(e),
                                    a = $(e).val();
                                void 0 == v.find(t => t.option3 == this.decodeOption(a)) ? i.attr("disabled", !0) : i.removeAttr("disabled")
                            })
                        }
                        break;
                    case 2:
                        if ($(r).find("[data-header-option]").text(a), "set-select" == n) {
                            $(r).find(".select__select").val(a);
                            var l = $(r).find(".select__select option");
                            l.each((t, e) => {
                                e.value == a ? $(e).attr("selected", "selected") : $(e).removeAttr("selected")
                            })
                        } else $(r).find(".product-form__radio").prop("checked", !1), $(r).find(`.product-form__radio[value="${this.encodeOption(a)}"]`).prop("checked", !0);
                        var y = t.filter(t => t.option3 === a);
                        if (e) {
                            var u = $(s[0]),
                                h = u.find(".product-form__radio"),
                                p = u.find(".select__select option");
                            "set-rectangle" == n ? h.each((t, e) => {
                                var i = $(e).next(),
                                    a = $(e).val();
                                void 0 == y.find(t => t.option1 == this.decodeOption(a)) ? i.removeClass("available").addClass("soldout") : i.removeClass("soldout").addClass("available")
                            }) : p.each((t, e) => {
                                var i = $(e),
                                    a = $(e).val();
                                void 0 == y.find(t => t.option1 == this.decodeOption(a)) ? i.attr("disabled", !0) : i.removeAttr("disabled")
                            })
                        }
                        if (i) {
                            var u = $(s[1]),
                                h = u.find(".product-form__radio");
                            "set-rectangle" == n ? h.each((t, e) => {
                                var i = $(e).next(),
                                    a = $(e).val();
                                void 0 == y.find(t => t.option2 == this.decodeOption(a)) ? i.removeClass("available").addClass("soldout") : i.removeClass("soldout").addClass("available")
                            }) : p.each((t, e) => {
                                var i = $(e),
                                    a = $(e).val();
                                void 0 == y.find(t => t.option2 == this.decodeOption(a)) ? i.attr("disabled", !0) : i.removeAttr("disabled")
                            })
                        }
                }
            })
        };
        if (r(s), r(o), this.item.find("[data-sku]").length > 0 && this.item.find("[data-sku] .productView-info-value").text(this.currentVariant.sku), null != this.currentVariant?.inventory_management) {
            var d = `product_inven_array_${this.dataset.product}`,
                n = window[d];
            if (void 0 != n) {
                var l = parseInt(n[this.currentVariant.id]);
                if (this.item.find('input[name="quantity"]').attr("data-inventory-quantity", l), this.item.find("[data-inventory]").length > 0 && (l > 0 ? this.item.find("[data-inventory] .productView-info-value").text(window.inventory_text.inStock) : this.item.find("[data-inventory] .productView-info-value").text(window.inventory_text.outOfStock)), this.item.find(".productView-hotStock").length > 0) {
                    var c = this.item.find(".productView-hotStock"),
                        u = c.data("hot-stock");
                    if (l > 0 && l <= u) {
                        var h = window.inventory_text.hotStock.replace("[inventory]", l);
                        c.text(h).show()
                    } else c.hide()
                }
            }
        }
    }
    updateAttribute(t = !0) {
        let e = document.getElementById(`product-form-${this.dataset.product}`)?.querySelector('[name="add"]'),
            i = document.getElementById(`product-form-sticky-${this.dataset.product}`)?.querySelector('[name="add"]');
        var a = $("[data-sticky-add-to-cart] .quantity__input"),
            s = this.item.find(".productView-notifyMe"),
            o = $("[data-sticky-add-to-cart] .sticky-price .money"),
            r = parseInt(a.attr("data-inventory-quantity"));
        if (0 === o.length && (o = $("[data-sticky-add-to-cart] .sticky-price .money-subtotal")), t) {
            var d = window.variantStrings.soldOut;
            this.item.removeClass("isChecked"), a.attr("data-price", this.currentVariant?.price), a.attr("disabled", !0), e.setAttribute("disabled", !0), e.textContent = d, i.setAttribute("disabled", !0), i.textContent = d, s.length > 0 && (s.find('input[name="halo-notify-product-variant"]').val(this.currentVariant.title), s.find(".notifyMe-text").empty(), s.slideDown("slow"))
        } else {
            var d, n = 0,
                l = this.currentVariant?.price;
            if (window.subtotal.show) {
                if (n = a.val() * l, n = Shopify.formatMoney(n, window.money_format), window.currencyFormatted && (n = $(n).text()), "1" == window.subtotal.style) {
                    let c = document.querySelector(".productView-subtotal .money") || document.querySelector(".productView-subtotal .money-subtotal");
                    c.textContent = n, d = this.currentVariant.available && r <= 0 ? window.variantStrings.preOrder : window.variantStrings.addToCart
                } else "2" == window.subtotal.style && (d = window.subtotal.text.replace("[value]", n))
            } else n = Shopify.formatMoney(l, window.money_format), window.currencyFormatted && (n = $(n).text()), d = this.currentVariant.available && r <= 0 ? window.variantStrings.preOrder : window.variantStrings.addToCart;
            this.item.addClass("isChecked"), a.attr("data-price", this.currentVariant?.price), a.attr("disabled", !1), e.removeAttribute("disabled"), e.textContent = d, i.removeAttribute("disabled"), i.textContent = d, 0 != n && o.length && o.text(n), s.length > 0 && s.slideUp("slow")
        }
    }
    getVariantData() {
        return this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent), this.variantData
    }
}
customElements.define("variant-sticky-selects", VariantStickyAddToCart);
class VariantStickyRadios extends VariantStickyAddToCart {
    constructor() {
        super()
    }
    connectedCallback() {
        this.updateMediaTimeout = void 0
    }
    onVariantChange(t) {
        this.updateOptions(), this.updateMasterId(), this.updatePickupAvailability(), this.updateMedia(10), this.updateURL(), this.updateVariantInput(), this.updateSelectVariant(), this.renderProductAjaxInfo(), this.renderProductInfo(), this.updateAttribute(!this.currentVariant.available)
    }
    updateOptions() {
        let t = Array.from(this.querySelectorAll("fieldset"));
        this.options = t.map(t => Array.from(t.querySelectorAll("input")).find(t => t.checked).value)
    }
    decodeOptions() {
        this.options = this.options.map(t => {
            let e = this.decodeOption(t);
            return e
        })
    }
    decodeOption(t) {
        return t ? t.split("Special_Double_Quote").join('"').split("Special_Slash").join("/") : null
    }
    encodeOption(t) {
        return t ? t.split('"').join("Special_Double_Quote").split("/").join("Special_Slash") : null
    }
    updateSelectVariant() {
        let t = this.closest(".productView-stickyCart").querySelector("select");
        t.value = this.currentVariant.id
    }
    updateMasterId() {
        this.decodeOptions(), this.currentVariant = this.getVariantData().find(t => !t.options.map((t, e) => this.options[e] === t).includes(!1))
    }
    updateMedia(t) {
        if (!this.currentVariant || !this.currentVariant?.featured_media) return;
        let e = this.item.find(".sticky-image"),
            i = this.currentVariant?.featured_image;
        if (!e) return;
        e.find("img").attr({
            src: i.src,
            srcset: i.src,
            alt: i.alt
        });
        let a = document.querySelectorAll(`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`);
        a && (clearTimeout(this.updateMediaTimeout), this.updateMediaTimeout = setTimeout(() => {
            $(a).trigger("click")
        }, t))
    }
    openStickyModal() {
        document.body.classList.add("show-mobile-options")
    }
    closeStickyModal() {
        document.body.classList.remove("show-mobile-options")
    }
}

function parseDoubleQuote(t, e = !0) {
    return t ? e ? t.replace('"', "spc_dbl_qte") : t.replace("spc_dbl_qte", '"') : t
}
customElements.define("variant-sticky-radios", VariantStickyRadios);